import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ym from 'react-yandex-metrika';

export function useMetrikaHit() {
  const { pathname, search, hash } = useLocation();
  const prevUrlRef = useRef<string>();

  useEffect(() => {
    const url = pathname + search + hash;
    const referer = prevUrlRef.current ?? (document.referrer || undefined);

    ym('hit', url, { title: document.title, referer }); // <- метод первым аргументом
    prevUrlRef.current = url;
  }, [pathname, search, hash]);
}
